<template>
  <div class="layout">
    <div class="back" @click="back">
      <div class="backIcon">
        <img src="../../assets/img/icon16.png" alt="" />
      </div>
      Back
    </div>
    <div class="box">
      <div class="title">Reservation Confirmation</div>
    </div>
    <div class="box">
      <div class="info">
        <div class="subTitle">Passenger Information</div>
        <div class="flight_no">flight number： {{ flightInfo.flight_no }}</div>
        <Form ref="formInline" :model="formTop" label-position="top">
          <FormItem label="Passenger Name">
            <Input v-model="formTop.name" disabled></Input>
          </FormItem>
          <FormItem label="Contact Number">
            <Input v-model="formTop.mobile" disabled></Input>
          </FormItem>
          <FormItem label="Number of Passengers">
            <Input v-model="formTop.user_num" disabled></Input>
          </FormItem>
          <FormItem label="Reservation Time">
            <Input v-model="formTop.airport_time" disabled></Input>
          </FormItem>
          <FormItem label="Remarks">
            <Input
              v-model="formTop.remake"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              placeholder="Please specify any special requirements..."
              class="textarea"
            ></Input>
          </FormItem>
        </Form>
      </div>
    </div>
    <div class="box">
      <div class="info">
        <div class="subTitle">Cost Details</div>
        <!-- <div class="row">
          <div class="feedName">Basic Pickup Service</div>
          <div class="price">$(NZD) {{ feed.baseFeed.toFixed(2) }}</div>
        </div> -->
        <div class="row">
          <div class="feedName">{{ car_type }} Service</div>
          <div class="price">$(NZD) {{ feed.extraFeed.toFixed(2) }}</div>
        </div>
        <div class="row">
          <div class="feedName">Total</div>
          <div class="price">$(NZD) {{ totalFeed.toFixed(2) }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="box">
      <div class="info">
        <div class="subTitle">Payment Methods</div>
        <div
          v-for="(item, index) in payMethods"
          :key="index"
          class="payRow"
          :class="{ active: selectedPay === index }"
          @click="selectPay(index)"
        >
          <div class="icon">
            <div class="iconBox">
              <img :src="item.icon" alt="" />
            </div>
            {{ item.name }}
          </div>
        </div>
      </div>
    </div> -->
    <div class="foot">
      <div class="confrmPay">
        <div class="box">
          Total Amount ：&nbsp;
          <div class="payPrice">$(NZD) {{ totalFeed.toFixed(2) }}</div>
        </div>
        <div class="btn" @click="pay">Confirm Payment</div>
      </div>
    </div>
    <div class="fill"></div>
  </div>
</template>

<script>
import { router } from "vue-router";
import { urlRequest } from "../../common/common";
import {serverUrl} from "../../api/api"
export default {
  name: "ReservationConfirm",
  data() {
    return {
      pay_type:[],
       car_type:"",
      id:"",
      flightInfo: {
        flight_no: "",
        departureTime: "14:00",
        arrivalTime: "17:30",
        departure: "Beijing Capital International Airport",
        destination: "Shanghai Pudong International Airport",
        state: 1,
        terminal: "Terminal 3",
      },
      payMethods: [
      ],
      selectedPay: -1,
      formTop: {
        name: "",
        mobile: "",
        user_num: "",
        airport_time: "",
        remake: "",
      },
      feed: {
        baseFeed: parseInt(this.$route.query.baseFeed),
        extraFeed: parseInt(this.$route.query.extraFeed),
      },
    };
  },
  computed: {
    totalFeed() {
      return this.feed.extraFeed;
    },
  },
  methods: {
    back() {
      this.$router.replace("/reservation");
        console.log('this.id'+this.id);

      urlRequest({
        url: this.api.cancelReservation+"?id="+this.id,
        method: "get"
      }).then((res) => {
        
        if (res.data.code === 200) {
          console.log("Order cancelled successfully");
        }
      });
    },
    selectPay(index) {
      this.selectedPay = index;
    },
    pay() {
      urlRequest({
        url: this.api.payReservation+'?id='+this.id,
        method: "get",
      }).then((res) => {
       if(res.data.code===200){
        console.log("pay success");
       }
      });
    },
    getReservationInfo() {
      const orderNo = this.$route.query.order_no;
       this.car_type = this.$route.query.car_type;
      console.log("OrderNo Type:", typeof orderNo, "Value:", orderNo); // 验证类型和值
      urlRequest({
        url: this.api.getReservationInfo + "?order_no=" + orderNo,
        method: "GET"
      }).then((res) => {
        console.log(res.data.data.data);
        
        if (res.data.code === 200) {
          console.log('res.data.data.data.luggage_num: '+res.data.data.data.luggage_num);
          
          this.flightInfo.flight_no = res.data.data.data.flight_no;
          this.formTop.mobile = res.data.data.data.mobile;
          this.formTop.name = res.data.data.data.name;
          this.formTop.user_num = res.data.data.data.user_num;
          this.formTop.airport_time = res.data.data.data.airport_time;
          this.feed.baseFeed = parseInt(res.data.data.data.car.price);
          this.feed.extraFeed = res.data.data.data.luggage_num>0?80:0;
          this.id=res.data.data.data.id;
          this.pay_type=res.data.data.pay_type;
          console.log('pay_type: '+this.pay_type);
          this.pay_type.forEach((item) => {
            this.payMethods.push({
              name: item.name,
              icon: serverUrl + item.icon,
            });
          });
          console.log('this.payMethods: '+JSON.stringify(this.payMethods));
          
        }
      });
    },
  },
  mounted() {
    this.getReservationInfo();
  },
};
</script>
<style lang="scss" scoped>
@import "reservationComfirm.scss";
</style>
